export default __webpack_public_path__ + "static/media/linkedin.ab7b6ff6.svg";